import { render, staticRenderFns } from "./coinSelect.vue?vue&type=template&id=4be7450a&"
import script from "./coinSelect.vue?vue&type=script&lang=js&"
export * from "./coinSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be7450a')) {
      api.createRecord('4be7450a', component.options)
    } else {
      api.reload('4be7450a', component.options)
    }
    module.hot.accept("./coinSelect.vue?vue&type=template&id=4be7450a&", function () {
      api.rerender('4be7450a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selectComponents/coinSelect.vue"
export default component.exports